import React from 'react'
import { useIntl } from 'react-intl'

export const useTranslatedAges = (): string[] => {
  const intl = useIntl()

  return [
    intl.formatMessage({
      id: 'widgets.reviews.add-review.age.not-born',
      defaultMessage: 'Not born yet',
    }),
    intl.formatMessage({
      id: 'widgets.reviews.add-review.age.0-6-months',
      defaultMessage: '0-6 Months',
    }),
    intl.formatMessage({
      id: 'widgets.reviews.add-review.age.7-12-months',
      defaultMessage: '7-12 Months',
    }),
    intl.formatMessage({
      id: 'widgets.reviews.add-review.age.13-24-months',
      defaultMessage: '13-24 Months',
    }),
    intl.formatMessage({
      id: 'widgets.reviews.add-review.age.24-months',
      defaultMessage: '24+ Months',
    }),
  ]
}
